import { render, staticRenderFns } from "./PaxCompatibilitesStallion.vue?vue&type=template&id=ac7fc92c&"
import script from "./PaxCompatibilitesStallion.vue?vue&type=script&lang=js&"
export * from "./PaxCompatibilitesStallion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports